import { PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React from 'react';

import { AcquisitionType } from '../types/types';

interface AcquisitionTypeSelectorProps {
  inactiveTypes: AcquisitionType[];
  onAdd: (type: AcquisitionType) => void;
}

const acquisitionLabels: Record<AcquisitionType, string> = {
  [AcquisitionType.Purchase]: 'Adicionar Compra',
  [AcquisitionType.Subscription]: 'Adicionar Assinatura',
  [AcquisitionType.Rental]: 'Adicionar Aluguel',
};

export const AcquisitionTypeSelector: React.FC<
  AcquisitionTypeSelectorProps
> = ({ inactiveTypes, onAdd }) => {
  if (inactiveTypes.length === 0) return null;

  return (
    <Space size={8} wrap>
      {inactiveTypes.map(type => (
        <Button
          key={type}
          type='dashed'
          size='middle'
          icon={<PlusOutlined style={{ width: 16, height: 16 }} />}
          onClick={() => onAdd(type)}
        >
          {acquisitionLabels[type]}
        </Button>
      ))}
    </Space>
  );
};
